import { render, staticRenderFns } from "./Abrir.vue?vue&type=template&id=d2ab5c10&scoped=true&"
import script from "./Abrir.vue?vue&type=script&lang=js&"
export * from "./Abrir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ab5c10",
  null
  
)

export default component.exports